// extracted by mini-css-extract-plugin
export default {"Modal":"Detail_Modal__2AvnR","Form":"Detail_Form__XE7bd"};